import cLoader from '@/extend/componentLoader'
import common from '@/assets/js/common'
import loadMix from './loadPerformance' //组件数据收集

function styleParser(style = {}) {
	styleParser.$div = styleParser.$div || document.createElement('div')
	const sortedStyle = Object.keys(style)
		.sort((a = '', b = '') => (a.length > b.length ? 1 : -1))
		.reduce((o, k) => {
			o += `${k}: ${style[k]};`
			return o
		}, '')
	styleParser.$div.setAttribute('style', sortedStyle)
	return styleParser.$div.style.cssText.split(/;\s*/).reduce((o, v = '') => {
		const arr = v.match(/^\s*([^:]+):\s*(.+)\s*$/)
		const info = arr ? { [arr[1]]: arr[2] } : {}
		return Object.assign(o, info)
	}, {})
}
export default {
	name: 'node',
	props: {
		info: {
			required: true,
			type: Object,
		},
	},
	data() {
		return {
			currPage: '',
			nodeCreatedTime: Date.now(),
		}
	},
	computed: {
		fixed() {
			return this.nodeInfo && this.nodeInfo.style.position == 'fixed'
		},
		isRootNode() {
			return (
				this.nodeInfo.id === 'root' ||
				this.nodeInfo.type === 'node' ||
				this.$parent.$options.name === 'widgetScene'
			)
		},
		computedStyle() {
			const sortedStyle = styleParser(this.nodeInfo.style)
			const slotStyle = typeof this.slotStyle === 'object' && this.slotStyle ? this.slotStyle : {}
			const resultStyle = Object.assign(
				{ 'pointer-events': this.packedChild ? 'none' : 'auto' },
				sortedStyle,
				slotStyle,
			)
			if (resultStyle && this.isRootNode) {
				resultStyle['transform'] = null
				resultStyle['min-height'] = `${window.innerHeight}px`
			}

			return resultStyle
		},
		parentNodeVm() {
			let $vm = this
			while ((($vm = $vm.$parent), $vm && $vm.$options.name !== 'node'));
			return $vm
		},
	},
	beforeCreate() {
		// console.log("parent-beforeCreate"+this._uid)
		// console.log(this)
	},
	mounted() {
		// console.log("parent-mounted"+this._uid)
	},
	methods: {
		async runAnimate({ clearFirst } = {}) {
			if (clearFirst && this.oldStyle) {
				this.$el.style.cssText = this.styleChangeStr(this.oldStyle)
				await this.$nextTick()
			}

			this.oldStyle = Object.assign({}, this.computedStyle)

			this.nodeInfo.animate = this.nodeInfo.animate || []
			const animateLength = this.nodeInfo.animate.length
			if (animateLength === 0) {
				return false
			}
			let initAnimateIndex = 0
			const parentNode = this.$el
			const me = this
			animateEndEvent()

			function animateEndEvent() {
				const oldStyle = me.styleChangeStr(me.oldStyle)
				const animate = me.nodeInfo.animate[initAnimateIndex]
				if (initAnimateIndex < animateLength) {
					const countNum = animate.infinite ? 'infinite' : animate.countNum
					let style = `
          -webkit-animation-name:${animate.type};
          -webkit-animation-duration:${animate.duration}s;
          -webkit-animation-iteration-count:${countNum};
          -webkit-animation-delay:${animate.delay}s;
          -webkit-animation-fill-mode:both;
          -webkit-animation-timing-function:${animate.timingFunction || 'ease'};
          `
					style += oldStyle + (!me.visible ? 'display:none;' : '')
					parentNode.style.cssText = style
					++initAnimateIndex
				}
				// else {
				//   parentNode.style.cssText = oldStyle
				// }
			}
			parentNode.addEventListener('animationend', animateEndEvent, false)
		},
		styleChangeStr(style) {
			let styleStr = ''
			for (const attr in style) {
				styleStr += `${attr.replace(/[A-Z]+/g, m => `-${m.toLowerCase()}`)}:${style[attr]};`
			}
			return styleStr
		},
		apiAspect(obj, extendKeys) {
			const self = this

			let keys = Object.keys(obj)
			if (extendKeys && extendKeys.length > 0) {
				keys = keys.concat(extendKeys)
			}

			const $apis = {}
			for (const key of keys) {
				if (typeof obj[key] === 'function') {
					$apis[key] = function (args) {
						args = args || {}
						if (typeof args === 'object') {
							args.$nodeId = self.nodeInfo.id
							args.$nodeLabel = self.nodeInfo.label
							args.$nodeType = self.nodeInfo.type
							args.$nodeVersion = self.nodeInfo.version
							args.$nodeCalcSuccessExpression = self.nodeInfo.calcSuccessExpression
							if (key === 'subscribe') {
								for (const [key, value] of Object.entries(self.nodeInfo.propEditorTypes)) {
									if (value === 'subscribe-config') {
										args.$nodeSubscribeConfig = self.nodeInfo.props[key]
									}
								}
							}
						}
						return obj[key](args)
					}
				} else {
					$apis[key] = obj[key]
				}
			}

			return $apis
		},
		registerNode(node) {
			const self = this
			const plugins = this.mixinsScript() // 返回构造对象数组
			const TempleteModule = Vue.extend(cLoader.getComponent(node))

			const $allBridge = this.apiAspect(window.AllBridge, ['setDebug', 'setConsoleLogLevel'])
			// TODO: 处理动态注入的问题
			const $allUI = this.apiAspect(this.$UI, [])
			const $allService = {
				resource: this.apiAspect(this.$Service.resource, []),
				award: this.apiAspect(this.$Service.award, []),
			}

			plugins.push({
				mixins: loadMix[node.type]
					? [loadMix[node.type], loadMix.commonNode]
					: [loadMix.commonNode], //组件数据收集，loadMix[node.type]为对应组件数据处理文件
				provide() {
					return {
						allBridge: $allBridge,
						allUI: $allUI,
						allService: $allService,
					}
				},
				data() {
					return {
						allBridge: $allBridge,
						allUI: $allUI,
						allService: $allService,
					}
				},
				beforeCreate() {
					const nodeInfo = this.$parent.lazyLoad
						? this.$parent.$parent.nodeInfo
						: this.$parent.nodeInfo
					const $parent = this.$parent.lazyLoad ? this.$parent.$parent : this.$parent
					const events = nodeInfo && nodeInfo.events
					if (!events || events.length <= 0) {
						return
					}
					for (const event of events) {
						$allBridge.log.info(
							`[common-events-on-register]`,
							`[${nodeInfo.type}@${nodeInfo.version}-${nodeInfo.id}]`,
							event.name,
							`\n${JSON.stringify(event)}`,
						)

						this.$on(event.name, params => {
							$allBridge.log.info(
								`[common-events-on-on]`,
								`[${nodeInfo.type}@${nodeInfo.version}-${nodeInfo.id}]`,
								event.name,
								`\n${JSON.stringify(params)}`,
							)
							event.listeners.forEach(listener => {
								try {
									let onComponent = $parent.getComponent(listener.nodeId, true)
									if (onComponent) {
										if (!onComponent._isVue) {
											onComponent = document.querySelector(`[data-node-id="${listener.nodeId}"]`)
										}
										onComponent[listener.actionName] && onComponent[listener.actionName](params)
									} else {
										window.app.$on(`$doLoadNode-${listener.nodeId}`, onComponent => {
											if (!onComponent._isVue) {
												onComponent = document.querySelector(`[data-node-id="${listener.nodeId}"]`)
											}
											onComponent[listener.actionName] && onComponent[listener.actionName](params)
										})
									}
								} catch (error) {
									console.error('common-events-on', event.name, error)
								}
							})
						})
					}
				},
				// fixme：这里会有性能问题
				// mounted() {
				//   this.allBridge
				//     .allCompCommonEventTrack({
				//       action: 'node_loaded',
				//       value: { timeCost: new Date().getTime() - this.$parent.loadBeginTime },
				//     })
				//     .then((res) => { })
				// },
			})

			// 迭代继承
			const MixedModule = plugins.reduce((a, b) => a.extend(b), TempleteModule)

			const component = Vue.component(this.nodeInfo.id, MixedModule)
		},
		/**
		 * ==============脚本注入===============
		 */
		mixinsScript() {
			window._script = window._script || {}
			if (this.nodeInfo.id) {
				let rawScript = []
				// 兼容老的Script位非数组的形式
				if (this.nodeInfo.script instanceof Array) {
					// 对数组的脚本兼容处理
					const pcs =
						window.pageInfo.content && JSON.parse(window.pageInfo.content).pageCommonScript
					if (pcs && pcs.length) {
						rawScript = this.nodeInfo.script.map(s => {
							if (typeof s === 'string') {
								return { content: s }
							}
							// 根据id补全s
							return (
								pcs.find(item => {
									return item.id === s.id && item.version === s.version
								}) || { content: 'return {}' }
							)
						})
					}

					const customScript = this.nodeInfo.script
						.map(s =>
							typeof s === 'string'
								? {
										content: s,
									}
								: s,
						)
						.filter(s => s && s.content && s.content.length > 0)

					if (customScript && customScript.length > 0) {
						rawScript = rawScript ? rawScript : []
						rawScript = rawScript.concat(customScript)
					}
				} else {
					// todo update 以下未知场景，未进行脚本优化相关处理
					rawScript = [
						this.nodeInfo.script && typeof this.nodeInfo.script === 'string'
							? { content: this.nodeInfo.script }
							: { content: 'return {}' },
					]
				}
				// 拼接脚本
				const combinedScript = `window._script['${this.nodeInfo.id}'] = function(vm){
          return [${rawScript
						.filter(({ content } = {}) => typeof content === 'string' && content.trim().length > 0)
						.map(({ content } = {}) => wrapper(content))
						.join(',')}].map(function(fn) {
            return fn(vm)
          })
        }`
				let result = []
				if (process.env.PAGE === 'EDITOR') {
					try {
						// 编译脚本
						const compiledScript = window.Babel.transform(combinedScript, {
							presets: ['es2015', 'es2017', 'stage-0'],
						}).code
						// 执行脚本
						window.eval(compiledScript)
						result = window._script[this.nodeInfo.id](this)
					} catch (e) {
						console.error('代码解析报错', e)
					}
				} else {
					window.eval(combinedScript)
					result = window._script[this.nodeInfo.id](this)
				}
				return result
			} else {
				return []
			}
			// 脚本包装
			function wrapper(script) {
				return `function(vm){
          var options = function (vm) {
          ${script}
          }(vm)
          return options
        }`
			}
		},
		/**
		 * 循环递归判断一个元素是否是显示状态，如果父元素有隐藏，则为隐藏状态
		 * @param {node} node
		 */
		isVisible(node) {
			let parentNode = node
			let flag = true
			while (parentNode && parentNode.nodeInfo) {
				if (parentNode.nodeInfo.visible == false) {
					flag = false
					break
				}
				parentNode = parentNode.$parent
			}
			return flag
		},
		/**
     * slots
      - false
      - true, 使用 slot0 slot1 slot2 slot3 ...
      - ['name1', 'name2'], 设置 childlimit，使用提供的名字
      - [{ name: 'name1', style: {width: '100%'}}, 'name2'], 同上，但是 slot 接管了子组件的样式
      - function (props) {}
      ----
      返回 slot 信息（闭包，参数为slot index），信息包括 slot名、强制样式 或者false
     */
		calcSlots(componentOpts, props) {
			if (!componentOpts) return false
			let slots = componentOpts.slots
			if (typeof slots === 'function') {
				slots = slots(props) || false
			}
			if (typeof slots === 'string') {
				this.$set(this.nodeInfo, 'hasSlot', true)
				return i => ({ name: slots, style: null })
			}
			if (typeof slots === 'object') {
				this.$set(this.nodeInfo, 'hasSlot', true)
				return i => slots
			}
			if (typeof slots === 'boolean' && slots) {
				this.nodeInfo.stack = false
				this.$set(this.nodeInfo, 'hasSlot', true)
				return i => ({ name: `slot${i}`, style: null })
			}
			if (slots instanceof Array && slots.length > 0) {
				this.nodeInfo.childLimit = slots.length
				this.nodeInfo.stack = false
				slots = slots.map((v, i) => {
					return {
						name: typeof v === 'string' ? v : (v && v.name) || `slot${i}`,
						style: typeof v === 'string' ? null : v && v.style,
					}
				})
				this.$set(this.nodeInfo, 'hasSlot', true)
				return i => slots[i]
			}

			if (slots && slots.style) {
				this.$set(this.nodeInfo, 'hasSlot', true)
				return i => ({ name: `slot${i}`, style: slots.style })
			}

			this.$delete(this.nodeInfo, 'hasSlot')
			return false
		},
	},
}
